import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useRefundBookingMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();
  const refundEventBooking = api.refundEventBooking;
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ eventId, bookingId }) => {
      if (!refundEventBooking) {
        throw new Error('Refunds are not available for this account');
      }

      const result = await refundEventBooking(eventId, bookingId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to process refund');
      }
      return result.data;
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (variables?.eventId) {
        await queryClient.invalidateQueries({ queryKey: queryKeys.detail(variables.eventId) });
      }
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
